import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=e406aa2c&"
import script from "./LayoutHeader.vue?vue&type=script&lang=ts&"
export * from "./LayoutHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports